var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#fff"},React.createElement("path",{"d":"M.893 0A.93.93 0 000 .893a.93.93 0 00.893.893h10.506a.93.93 0 00.893-.893A.93.93 0 0011.4 0zM.893 4.186A.93.93 0 000 5.08a.93.93 0 00.893.893h10.506a.93.93 0 00.893-.893.93.93 0 00-.893-.893zM.893 8.372A.93.93 0 000 9.265a.93.93 0 00.893.893h10.506a.93.93 0 00.893-.893.93.93 0 00-.893-.893z"})));
}

Hamburger.defaultProps = {"viewBox":"0 0 12.292 10.158"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
